export default function createUrl(
  base: string,
  params: Record<string, string>,
) {
  const query = new URLSearchParams(params);
  return new URL(`?${query}`, base).toString();
}
